import {
    GET_FOOD_RECIPES_SUCCESS,
    GET_FOOD_RECIPES_FAILURE
} from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getFoodRecipesSuccess = payload => {
    return ({
        type: GET_FOOD_RECIPES_SUCCESS,
        payload
    })
}

export const getFoodRecipesFailure = payload => ({
    type: GET_FOOD_RECIPES_FAILURE
})

export const getFoodRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('food-recipes', getFoodRecipesSuccess, 0));
}